import { Cog } from "lucide-react";
import { Button } from "@/components/ui/button";
import type { CanvasNode } from "@opus-dt/shared-types";

interface MachineFormProps {
  node: CanvasNode;
  onOpenSidebar?: (node: CanvasNode, options?: { canvasAdd?: boolean }) => void;
}

export function MachineForm({ node, onOpenSidebar }: MachineFormProps) {
  return (
    <div className="bg-muted/20 space-y-2 rounded-md border p-3">
      <div className="flex items-center gap-2 text-sm">
        <Cog className="text-muted-foreground h-4 w-4" />
        <span className="font-medium">Configuração da máquina</span>
      </div>
      {node.data?.machineId ? (
        <>
          <p className="text-muted-foreground text-xs">
            Vinculada a uma máquina cadastrada. Use o painel completo para editar dados, parâmetros,
            sensores, compatibilidades e alarmes.
          </p>
          <Button
            size="sm"
            variant="outline"
            className="w-full"
            onClick={() => onOpenSidebar?.(node)}
          >
            Abrir painel completo
          </Button>
        </>
      ) : (
        <>
          <p className="text-muted-foreground text-xs">
            Configure os dados básicos para vincular esta máquina à linha.
          </p>
          <Button
            size="sm"
            className="w-full"
            onClick={() => onOpenSidebar?.(node, { canvasAdd: true })}
          >
            Configurar máquina
          </Button>
        </>
      )}
    </div>
  );
}
